import { httpService } from "../../HttpService";
import { Result } from "../../../models/Result";

export interface SanctionsList {
    id: string;
    name: string;
    data: any;
}

export interface WhitelistRequest {
    reason: string;
    attachment: File;
}

export interface WhitelistResponse {
    success: boolean;
    message: string;
}

// Envelope returned by risk API for sanctions search
export interface AmlSanctionEnvelope {
    result: unknown;
    value: AmlSanction[];
}

export interface AmlSanction {
    id: number;
    createDate: string;
    createdByClientId: string;
    updatedAt: string;
    cbsId: string;
    watchlistEntryId: string;
    status: string; // Blocked | Whitelisted | Escalated
    reason: string;
    createdBy: string;
    revokedBy: string;
    revokedAt: string | null;
    documentId: string | null;
    validFrom: string | null;
    validTo: string | null;
    // Extended fields from API
    jsonResponse?: any;
    sanctionCategory?: string;
}

// API response structure
export interface NilListEntry {
    cbsId: string;
    watchlistEntryId: string;
    rabbitResponseJson: any;
    sanctionCategory: string;
}

export interface SanctionsResponse {
    detailedJson?: {
        MinimumMatchingPercentageNIL?: number;
        MinimumMatchingPercentagePEP?: number;
        ConsumedTimeInMs?: number;
        ClientId?: string;
        watchListEntryEsDto?: any[];
    };
    nilLists: NilListEntry[];
}

class SanctionsApiService {
    path: string = "Aml";
    baseApiUrl = process.env.REACT_APP_RISK_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;

    getSanctions = async (cbsId: string, status?: string): Promise<Result<AmlSanctionEnvelope | AmlSanction[]>> => {
        const qp = status ? `?status=${encodeURIComponent(status)}` : "";
        return await httpService.get<AmlSanctionEnvelope | AmlSanction[]>(`/${this.path}/sanctions/${encodeURIComponent(cbsId)}${qp}`, { baseURL: this.baseApiUrl });
    };

    whitelistCustomer = async (body: {
        cbsId: string;
        watchlistEntryIds: string[];
        reason: string;
        fileName: string;
        fileData: string; // base64
    }): Promise<Result<string>> => {
        return await httpService.post<string>(`/${this.path}/whitelist`, body, { baseURL: this.baseApiUrl, headers: { 'Content-Type': 'application/json' } });
    };
}

export const sanctionsApiService = new SanctionsApiService();
